import { queries } from "./profile.queries";
import { selectors } from "./profile.selectors";
import { actions } from "./profile.actions";

export const profile = {
  actions: actions,
  selectors: selectors,
  queries: queries,
};
